import React from "react";
import { Check } from "lucide-react";
import { useLang } from "@/i18n";
import { Reveal, MaskedLineOnScroll } from "@/lib/motion";

export default function Machinery() {
  const { t } = useLang();
  return (
    <section id="machinery" data-testid="machinery-section" className="relative py-28 lg:py-40 max-w-[1400px] mx-auto px-6 lg:px-10">
      <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        {/* Images bento */}
        <div className="lg:col-span-6 grid grid-cols-2 gap-4">
          <Reveal className="row-span-2 group overflow-hidden clip-frame">
            <img src="/images/p4.jpg" alt="Robot di lavorazione Olmi" className="w-full h-full object-cover spotlight-img min-h-[340px]" />
          </Reveal>
          <Reveal delay={0.1} className="group overflow-hidden clip-frame-tl">
            <img src="/images/p3.jpg" alt="Cella robotizzata di lucidatura" className="w-full h-56 object-cover spotlight-img" />
          </Reveal>
          <Reveal delay={0.2} className="group overflow-hidden clip-frame">
            <img src="/images/p10.jpg" alt="Braccio robotico Olmi al lavoro" className="w-full h-56 object-cover spotlight-img" />
          </Reveal>
        </div>

        {/* Text */}
        <div className="lg:col-span-6">
          <Reveal>
            <span className="font-accent text-xs md:text-sm tracking-[0.25em] uppercase text-[#D4AF37]">{t.machinery.overline}</span>
          </Reveal>
          <h2 className="mt-6 font-display text-4xl md:text-5xl font-medium tracking-tight text-white leading-[1.05]">
            <MaskedLineOnScroll>{t.machinery.title}</MaskedLineOnScroll>
          </h2>
          <Reveal delay={0.1}>
            <p className="mt-8 text-base md:text-lg text-zinc-400 leading-relaxed max-w-xl">{t.machinery.p}</p>
          </Reveal>
          <Reveal delay={0.2} className="mt-10 space-y-4">
            {t.machinery.features.map((f) => (
              <div key={f} className="flex items-start gap-4 border-l border-white/10 pl-5 py-1" data-testid="machinery-feature">
                <Check className="shrink-0 mt-1 text-[#D4AF37]" size={18} />
                <span className="text-base text-zinc-300">{f}</span>
              </div>
            ))}
          </Reveal>
        </div>
      </div>
    </section>
  );
}
